import { render, staticRenderFns } from "./SintesisPage.vue?vue&type=template&id=680edf9b"
import script from "./SintesisPage.js?vue&type=script&lang=js&external"
export * from "./SintesisPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports